function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (a, b) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = b(require("@babel/runtime/helpers/objectWithoutProperties"), require("@babel/runtime/helpers/classCallCheck"), require("@babel/runtime/helpers/createClass"), require("@babel/runtime/helpers/possibleConstructorReturn"), require("@babel/runtime/helpers/getPrototypeOf"), require("@babel/runtime/helpers/assertThisInitialized"), require("@babel/runtime/helpers/inherits"), require("@babel/runtime/helpers/defineProperty"), require("react"), require("prop-types")) : "function" == typeof define && define.amd ? define(["@babel/runtime/helpers/objectWithoutProperties", "@babel/runtime/helpers/classCallCheck", "@babel/runtime/helpers/createClass", "@babel/runtime/helpers/possibleConstructorReturn", "@babel/runtime/helpers/getPrototypeOf", "@babel/runtime/helpers/assertThisInitialized", "@babel/runtime/helpers/inherits", "@babel/runtime/helpers/defineProperty", "react", "prop-types"], b) : (a = a || self, a.Img = b(a._objectWithoutProperties, a._classCallCheck, a._createClass, a._possibleConstructorReturn, a._getPrototypeOf, a._assertThisInitialized, a._inherits, a._defineProperty, a.React, a.propTypes));
})(this, function (a, b, c, d, e, f, g, h, i, j) {
  'use strict';

  function k(a, b) {
    var c = Object.keys(a);

    if (Object.getOwnPropertySymbols) {
      var d = Object.getOwnPropertySymbols(a);
      b && (d = d.filter(function (b) {
        return Object.getOwnPropertyDescriptor(a, b).enumerable;
      })), c.push.apply(c, d);
    }

    return c;
  }

  function l(a) {
    for (var b, c = 1; c < arguments.length; c++) {
      b = null == arguments[c] ? {} : arguments[c], c % 2 ? k(Object(b), !0).forEach(function (c) {
        h(a, c, b[c]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : k(Object(b)).forEach(function (c) {
        Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
      });
    }

    return a;
  }

  a = a && a.hasOwnProperty("default") ? a["default"] : a, b = b && b.hasOwnProperty("default") ? b["default"] : b, c = c && c.hasOwnProperty("default") ? c["default"] : c, d = d && d.hasOwnProperty("default") ? d["default"] : d, e = e && e.hasOwnProperty("default") ? e["default"] : e, f = f && f.hasOwnProperty("default") ? f["default"] : f, g = g && g.hasOwnProperty("default") ? g["default"] : g, h = h && h.hasOwnProperty("default") ? h["default"] : h;

  var m = "default" in i ? i["default"] : i,
      n = {},
      o = {
    loader: j.node,
    unloader: j.node,
    decode: j.bool,
    crossorigin: j.string,
    src: j.oneOfType([j.string, j.array]),
    container: j.func,
    loaderContainer: j.func,
    unloaderContainer: j.func
  },
      p = function (i) {
    function j(a) {
      var c;
      b(this, j), c = d(this, e(j).call(this, a)), h(f(c), "srcToArray", function (a) {
        return (Array.isArray(a) ? a : [a]).filter(function (a) {
          return a;
        });
      }), h(f(c), "onLoad", function () {
        n[c.sourceList[c.state.currentIndex]] = !0, c.i && c.setState({
          isLoaded: !0
        });
      }), h(f(c), "onError", function () {
        if (n[c.sourceList[c.state.currentIndex]] = !1, !c.i) return !1;

        for (var a, b = c.state.currentIndex + 1; b < c.sourceList.length; b++) {
          if (a = c.sourceList[b], !(a in n)) {
            c.setState({
              currentIndex: b
            });
            break;
          }

          if (!0 === n[a]) return c.setState({
            currentIndex: b,
            isLoading: !1,
            isLoaded: !0
          }), !0;
          !1 === n[a];
        }

        return b === c.sourceList.length ? c.setState({
          isLoading: !1
        }) : void c.loadImg();
      }), h(f(c), "loadImg", function () {
        c.i = new Image(), c.i.src = c.sourceList[c.state.currentIndex], c.props.crossorigin && (c.i.crossOrigin = c.props.crossorigin), c.props.decode && c.i.decode ? c.i.decode().then(c.onLoad)["catch"](c.onError) : (c.i.onload = c.onLoad, c.i.onerror = c.onError);
      }), h(f(c), "unloadImg", function () {
        c.i.onerror = null, c.i.onload = null, c.i.src = "";

        try {
          delete c.i.src;
        } catch (a) {}

        delete c.i;
      }), c.loaderContainer = a.loaderContainer || a.container, c.unloaderContainer = a.unloaderContainer || a.container, c.sourceList = c.srcToArray(c.props.src);

      for (var g = 0; g < c.sourceList.length && !!(c.sourceList[g] in n); g++) {
        if (!0 === n[c.sourceList[g]]) return c.state = {
          currentIndex: g,
          isLoading: !1,
          isLoaded: !0
        }, d(c);
      }

      return c.state = c.sourceList.length ? {
        currentIndex: 0,
        isLoading: !0,
        isLoaded: !1
      } : {
        isLoading: !1,
        isLoaded: !1
      }, c;
    }

    return g(j, i), c(j, [{
      key: "componentDidMount",
      value: function value() {
        this.state.isLoading && this.loadImg();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.i && this.unloadImg();
      }
    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function value(a) {
        var b = this;
        this.loaderContainer = a.loaderContainer || a.container, this.unloaderContainer = a.unloaderContainer || a.container;
        var c = this.srcToArray(a.src),
            d = c.filter(function (a) {
          return -1 === b.sourceList.indexOf(a);
        }),
            e = this.sourceList.filter(function (a) {
          return -1 === c.indexOf(a);
        });

        if (d.length || e.length) {
          if (this.sourceList = c, !c.length) return this.setState({
            isLoading: !1,
            isLoaded: !1
          });
          this.setState({
            currentIndex: 0,
            isLoading: !0,
            isLoaded: !1
          }, this.loadImg);
        }
      }
    }, {
      key: "render",
      value: function value() {
        var b = this.props,
            c = b.container,
            d = b.loader,
            e = b.unloader,
            f = b.src,
            g = b.decode,
            h = b.loaderContainer,
            i = b.unloaderContainer,
            j = b.mockImage,
            k = a(b, ["container", "loader", "unloader", "src", "decode", "loaderContainer", "unloaderContainer", "mockImage"]);

        if (this.state.isLoaded) {
          var n = l({}, {
            src: this.sourceList[this.state.currentIndex]
          }, {}, k);
          return c(m.createElement("img", n));
        }

        return !this.state.isLoaded && this.state.isLoading ? d ? this.loaderContainer(d) : null : this.state.isLoaded || this.state.isLoading ? void 0 : e ? this.unloaderContainer(e) : null;
      }
    }]), j;
  }(i.Component);

  return h(p, "defaultProps", {
    loader: !1,
    unloader: !1,
    decode: !0,
    src: [],
    container: function container(a) {
      return a;
    }
  }), p.propTypes = {}, p;
});